
/**
 * Module dependencies.
 */

import {
  authRequest,
  authorizationHeader,
  handleRequestError
} from 'src/core/utils/requests';

import { getAuthApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  formData: {
    email: string,
    oldPassword: string,
    password: string
  },
  token: string
};

/**
 * Endpoints.
 */

const changePasswordEndpoint = getAuthApiEndpoint('changePassword');
const createTokenEndpoint = getAuthApiEndpoint('createToken');

/**
 * Export `changePassword`.
 */

export async function changePassword({ formData, token }: Query) {
  const { email, oldPassword, password } = formData;

  return await authRequest.post(changePasswordEndpoint, {
    oldPassword,
    password
  }, {
    headers: authorizationHeader(token)
  })
    .then(async () => {
      const { data } = await authRequest.post(createTokenEndpoint, {
        email,
        password
      }, {
        headers: authorizationHeader(token)
      });

      return data?.data;
    })
    .catch(error => {
      throw handleRequestError(error);
    });
}
